export const environment = {
  production: false,
  BaseUrl: 'https://dev.gateway-juridico.srv1954566.hstgr.cloud/api',
  // Host desde el que se sirven los logos de las empresas (el nombre del archivo lo da
  // `logo` del catalogo de internas). Vacio = la pantalla cae al icono de la zona, que es
  // lo mismo que se veia antes de que hubiera logos: no hay imagenes rotas.
  // OJO: en https. El host responde en http con un 301, y un `<img src="http://...">` en
  // una pagina servida por https es contenido mixto y el navegador lo bloquea.
  imagesUrl: 'https://images.srv1954566.hstgr.cloud/',
  /**
   * El servicio de IDENTIDAD, que contesta `GET /sesion/actual` y
   * `POST /sesion/elegir-acceso`. Lo consume `proveerSesion` en `app.config.ts`.
   */
  identidadUrl: 'https://dev.srv1954566.hstgr.cloud/api/v1',
  logoutUrl: 'https://dev.srv1954566.hstgr.cloud/',
  socketUrl: 'http://localhost:3000', // URL del servidor Socket.IO
  fileManagerSystemId: 13, // ID del sistema de facturación para FileManager (consultar con backend si es diferente)
};
